import React, { memo } from "react";
import { Box, Stack, Typography, Button } from "@mui/material";
import { useSearchParams, useNavigate } from "react-router-dom";

const ThankYouIllustration = () => (
  <svg
    width="200"
    height="200"
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Ground/Land */}
    <ellipse cx="100" cy="170" rx="90" ry="20" fill="#50b588" opacity="0.3" />

    {/* House base */}
    <rect x="60" y="90" width="80" height="70" fill="#004B4C" />

    {/* Roof */}
    <polygon points="50,90 100,45 150,90" fill="#004B4C" />

    {/* Door */}
    <rect x="90" y="120" width="20" height="40" fill="#fcede2" />
    <circle cx="105" cy="142" r="2" fill="#004B4C" />

    {/* Windows */}
    <rect x="70" y="100" width="15" height="15" fill="#fcede2" />
    <rect x="115" y="100" width="15" height="15" fill="#fcede2" />

    {/* Window crosses */}
    <line x1="77.5" y1="100" x2="77.5" y2="115" stroke="#004B4C" strokeWidth="1" />
    <line x1="70" y1="107.5" x2="85" y2="107.5" stroke="#004B4C" strokeWidth="1" />
    <line x1="122.5" y1="100" x2="122.5" y2="115" stroke="#004B4C" strokeWidth="1" />
    <line x1="115" y1="107.5" x2="130" y2="107.5" stroke="#004B4C" strokeWidth="1" />

    {/* Chimney */}
    <rect x="120" y="55" width="15" height="25" fill="#004B4C" />

    {/* Trees */}
    <circle cx="30" cy="130" r="20" fill="#50b588" />
    <rect x="27" y="145" width="6" height="25" fill="#004B4C" />

    <circle cx="170" cy="125" r="25" fill="#50b588" />
    <rect x="167" y="145" width="6" height="25" fill="#004B4C" />

    {/* Checkmark circle */}
    <circle cx="160" cy="40" r="25" fill="#50b588" />
    <polyline
      points="148,40 157,50 173,32"
      stroke="white"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

const ThankYou = memo(() => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const customMessage = searchParams.get("message");
  const displayMessage =
    customMessage && customMessage.trim()
      ? customMessage
      : "You're officially part of the Simpler Home community!";

  return (
    <Box
      sx={{
        p: {
          xl: "60px 80px",
          lg: "60px 80px",
          md: "40px 20px",
          sm: "40px 20px",
          xs: "40px 20px",
        },
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Stack
        direction="column"
        spacing={3}
        alignItems="center"
        textAlign="center"
        sx={{ maxWidth: 550 }}
      >
        <ThankYouIllustration />

        <Typography
          variant="h4"
          sx={{
            color: "primary.main",
            fontWeight: 600,
          }}
        >
          Welcome Aboard!
        </Typography>

        <Typography
          variant="body1"
          component="div"
          sx={{
            color: "text.primary",
            fontSize: "1.1rem",
            lineHeight: 1.6,
          }}
        >
          {displayMessage}
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: "text.secondary",
            fontSize: "0.95rem",
            maxWidth: 450,
          }}
        >
          Keep an eye on your inbox for expert tips on finding your perfect home,
          exclusive listings, and the latest real estate insights.
        </Typography>

        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => navigate("/")}
          sx={{
            mt: 2,
            px: 4,
            py: 1.5,
            borderRadius: 2,
          }}
        >
          Explore Homes
        </Button>
      </Stack>
    </Box>
  );
});

export default ThankYou;
